export function updateSettings(data) {
  return { type: 'SETTINGS_UPDATE', data };
}
